/**
 * meetingTokenInput.ts — shared predicates for when Schedule Flow meeting tokens should fetch.
 *
 * Why: Zoom locations sometimes return a join URL without a meeting ID. Schedule Flow must still
 * treat that as a real link so VIDEO_MEETING_LINK and related tokens populate before send.
 */
import type { TokenVideoMeetingLinkInput, TokenZoomMeetingInput } from 'src/generated/mloop-graphql';

import { EMPTY_UUID } from 'src/constants';

/** Returns true when the video meeting link input has enough data to resolve VIDEO_MEETING_LINK. */
export const hasVideoMeetingLinkFromInput = (videoMeetingLinkInput: TokenVideoMeetingLinkInput): boolean => {
  return !!(
    videoMeetingLinkInput.customVideoMeetingLinkUrl ||
    videoMeetingLinkInput.videoMeetingLink ||
    videoMeetingLinkInput.zoomInfo?.joinUrl ||
    (videoMeetingLinkInput.zoomInfo?.meetingId && videoMeetingLinkInput.zoomInfo?.meetingId !== EMPTY_UUID)
  );
};

/** Returns true when zoom dial-in/info tokens should be fetched for the meeting input. */
export const hasZoomMeetingFromInput = (zoomInput: TokenZoomMeetingInput): boolean => {
  return !!(zoomInput.joinUrl || (zoomInput.meetingId && zoomInput.meetingId !== EMPTY_UUID));
};
